export default {"src":"/_next/static/media/apple-touch-icons.f7bafbd2.ico","height":180,"width":180};